import { Fragment, useMemo, useState } from "react";

import ChipsFilter from "components/chipsFilter/chipsFilter";
import TextButton from "components/textButton/TextButtonLegacy";

import type { LeaderboardPage } from "lib/types/leaderboards";

import {
  findLatestPublishDateId,
  getFilterList,
  getGroupedLeaderboards,
} from "content-ui/leaderboards/lib";
import { LeaderboardCard } from "../leaderboardCard/leaderboardCard";

export const ListView = ({ data }) => {
  const [activeFilters, setActiveFilters] = useState<string[]>([]);

  const handleFilterUpdate = (filter: string[]) => {
    setActiveFilters(filter);
  };

  const groupedLeaderboards = useMemo(
    () => getGroupedLeaderboards(data.leaderboards, activeFilters),
    [activeFilters, data.leaderboards]
  );

  const filterList = useMemo(
    () => getFilterList(data.leaderboards),
    [data.leaderboards]
  );

  const latestId = useMemo(
    () =>
      findLatestPublishDateId([
        ...data.latestSectionLeaderboards,
        ...data.leaderboards,
      ]),
    [data.latestSectionLeaderboards, data.leaderboards]
  );

  return (
    <div data-testid="list-view">
      <>
        <div className={"mb-[12px] flex items-center justify-between"}>
          <h4 className={"inline-flex font-bold text-[16px]"}>Filter</h4>
          <div className={"flex"}>
            <TextButton
              colour={"black"}
              component={"button"}
              onClick={async () => handleFilterUpdate([])}
            >
              Reset
            </TextButton>
          </div>
        </div>
        <div className="md:px-5 lg:px-0 first:[&_li]:md:pl-0">
          {filterList.length > 0 && (
            <ChipsFilter
              type={"multiple"}
              selected={activeFilters}
              list={filterList.map(({ value, label }) => ({
                value,
                label,
              }))}
              onChange={(selected: string[]) => handleFilterUpdate(selected)}
            />
          )}
        </div>
      </>
      {groupedLeaderboards.map((yearGroup: [string, LeaderboardPage[]], i) => {
        return (
          <Fragment key={i}>
            <div className="mb-[24px] mt-[30px] flex items-center">
              <div className="w-100 border-b-[1px] border-mono-20"></div>
              <div className="mx-[10px] text-[18px] text-mono-30">
                {yearGroup[0]}
              </div>
              <div className="w-100 border-b-[1px] border-mono-20"></div>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
              {yearGroup[1].map((leaderboard, i) => {
                return (
                  <div key={i} className="min-h-[435px] w-100">
                    <LeaderboardCard
                      leaderboard={leaderboard}
                      latestId={latestId}
                    />
                  </div>
                );
              })}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
